import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import EventManagement from "./EventManagement";
import api from "../api";
import Toast from "./Toast";

const EventManagementWrapper = ({ events, fetchEvents }) => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('youmak_user'));
    if (events.length > 0 && eventId) {
      const found = events.find((e) => e._id === eventId || e.id === eventId);
      if (found) {
        setSelectedEvent(found);
      } else {
        // If not found in local state, maybe try fetching directly or redirect
        navigate(user?.role === 'admin' ? "/admin" : "/client");
      }
    }
  }, [eventId, events, navigate]);

  const updateEventDetails = async () => {
    try {
      await api.put(
        `/api/events/${selectedEvent._id || selectedEvent.id}`,
        selectedEvent
      );
      setToast({ type: "success", message: "تم تحديث البيانات بنجاح." });
      setIsEditing(false);
      fetchEvents(true);
    } catch {
      setToast({ type: "danger", message: "فشل تحديث البيانات." });
    }
  };

  if (!selectedEvent) return <div className="p-5 text-center">جاري التحميل...</div>;

  const user = JSON.parse(localStorage.getItem('youmak_user'));

  return (
    <>
      <EventManagement
        event={selectedEvent}
        onBack={() => navigate(user?.role === 'admin' ? "/admin" : "/client")}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        updateEventDetails={updateEventDetails}
        setEventDetails={setSelectedEvent}
        user={JSON.parse(localStorage.getItem('youmak_user'))}
      />
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default EventManagementWrapper;
